__turbopack_context__.v({
  "bannerGroup": "CondensedProductCard-module__IaczYq__bannerGroup",
  "buttonsRow": "CondensedProductCard-module__IaczYq__buttonsRow",
  "card": "CondensedProductCard-module__IaczYq__card",
  "cardTightSpacing": "CondensedProductCard-module__IaczYq__cardTightSpacing",
  "condensedTrustSignals": "CondensedProductCard-module__IaczYq__condensedTrustSignals",
  "desktopAttributes": "CondensedProductCard-module__IaczYq__desktopAttributes",
  "desktopImages": "CondensedProductCard-module__IaczYq__desktopImages",
  "desktopImagesVariant": "CondensedProductCard-module__IaczYq__desktopImagesVariant",
  "desktopLayout": "CondensedProductCard-module__IaczYq__desktopLayout",
  "desktopProductInfo": "CondensedProductCard-module__IaczYq__desktopProductInfo",
  "hideCarouselArrows": "CondensedProductCard-module__IaczYq__hideCarouselArrows",
  "iconButton": "CondensedProductCard-module__IaczYq__iconButton",
  "imageInfoRow": "CondensedProductCard-module__IaczYq__imageInfoRow",
  "infoLine": "CondensedProductCard-module__IaczYq__infoLine",
  "infoLineIcon": "CondensedProductCard-module__IaczYq__infoLineIcon",
  "infoSections": "CondensedProductCard-module__IaczYq__infoSections",
  "likeOverlay": "CondensedProductCard-module__IaczYq__likeOverlay",
  "mainImage": "CondensedProductCard-module__IaczYq__mainImage",
  "mobileAttributes": "CondensedProductCard-module__IaczYq__mobileAttributes",
  "productInfo": "CondensedProductCard-module__IaczYq__productInfo",
  "productInfoPrice": "CondensedProductCard-module__IaczYq__productInfoPrice",
  "sellerActionButton": "CondensedProductCard-module__IaczYq__sellerActionButton",
  "sellerActionsDesktop": "CondensedProductCard-module__IaczYq__sellerActionsDesktop",
  "sellerActionsMobile": "CondensedProductCard-module__IaczYq__sellerActionsMobile",
  "sellerRow": "CondensedProductCard-module__IaczYq__sellerRow",
  "tabletImage": "CondensedProductCard-module__IaczYq__tabletImage",
  "thumbnail": "CondensedProductCard-module__IaczYq__thumbnail",
  "thumbnailActive": "CondensedProductCard-module__IaczYq__thumbnailActive",
  "thumbnailImage": "CondensedProductCard-module__IaczYq__thumbnailImage",
  "thumbnailStrip": "CondensedProductCard-module__IaczYq__thumbnailStrip",
  "titlePriceGroup": "CondensedProductCard-module__IaczYq__titlePriceGroup",
  "viewDetailsButton": "CondensedProductCard-module__IaczYq__viewDetailsButton",
});
